import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MapDriver {
  id: string;
  name: string;
  code: string;
  // vehicle: string;
  // vehicleNumber: string;
  image: string;
  latitude: string;
  longitude: string;
  // accuracy?: number;
  // speed: number;
  // direction: number;
  currentLocation?: string;
  // destination?: string;
  // ordersToday?: number;
  // ordersCompleted?: number;
  // rating?: number;
  online: boolean;
  lat: number;
  lon: number;
  // heading: number;
  // route?: { lat: number; lon: number }[];
  totalShipments?: number;
  outForDelivery?: number;
  ordersDelivered?: number;
  ordersNotDelivered?: number;
}

interface DriverMapState {
  drivers: MapDriver[];
  loading: boolean;
  error: string | null;
  socketConnected: boolean;
  lastUpdate: number | null;
}

const initialState: DriverMapState = {
  drivers: [],
  loading: false,
  error: null,
  socketConnected: false,
  lastUpdate: null,
};

const driverMapSlice = createSlice({
  name: 'driverMap',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    setSocketConnected(state, action: PayloadAction<boolean>) {
      state.socketConnected = action.payload;
    },

    setDrivers(state, action: PayloadAction<MapDriver[]>) {
      state.drivers = action.payload;
      state.loading = false;
      state.error = null;
      state.lastUpdate = Date.now();
    },

    updateDriverLocation(state, action: PayloadAction<Partial<MapDriver> & { id: string }>) {
      const index = state.drivers.findIndex(d => d.id === action.payload.id);
      
      if (index !== -1) {
        state.drivers[index] = {
          ...state.drivers[index],
          ...action.payload,
        };
      } else {
        state.drivers.push(action.payload as MapDriver);
      }
      
      state.lastUpdate = Date.now();
    },

    updateMultipleDrivers(state, action: PayloadAction<Partial<MapDriver>[]>) {
      action.payload.forEach(update => {
        if (!update.id) return;
        
        const index = state.drivers.findIndex(d => d.id === update.id);
        
        if (index !== -1) {
          state.drivers[index] = {
            ...state.drivers[index],
            ...update,
          };
        } else {
          state.drivers.push(update as MapDriver);
        }
      });
      
      state.lastUpdate = Date.now();
    },

    setDriverOnlineStatus(state, action: PayloadAction<{ id: string; online: boolean }>) {
      const index = state.drivers.findIndex(d => d.id === action.payload.id);
      if (index !== -1) {
        state.drivers[index].online = action.payload.online;
        state.lastUpdate = Date.now();
      }
    },

    removeOfflineDrivers(state) {
      state.drivers = state.drivers.filter(d => d.online);
      state.lastUpdate = Date.now();
    },

    clearDrivers(state) {
      state.drivers = [];
      state.error = null;
      state.lastUpdate = null;
    },
  },
});

export const {
  setLoading,
  setError,
  setSocketConnected,
  setDrivers,
  updateDriverLocation,
  updateMultipleDrivers,
  setDriverOnlineStatus,
  removeOfflineDrivers,
  clearDrivers,
} = driverMapSlice.actions;

export default driverMapSlice.reducer;
